<template>
  <div id="app">
    <menu-comp></menu-comp>
    <div class="wrapper__max">
      <transition
        name="fade"
        mode="out-in">
        <router-view></router-view>
      </transition> 
    </div>
    <footer-comp></footer-comp>
    <popin />
  </div>
</template>

<script>
import Vue from 'vue'
import FooterComp from './components/Footer.vue';
import MenuComp from './components/Menu.vue';
import Popin from './components/Popin.vue';
import inViewportDirective from 'vue-in-viewport-directive'
Vue.directive('in-viewport', inViewportDirective)

// import Image from './components/Image.vue';
// Vue.component('c-image', Image);
let tickScroll = false

export default {
  name: 'app',
  components: { MenuComp, FooterComp, Popin },
  methods:{
    _getScrollTop(){
      return window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0)
    },
    loop(){
      requestAnimationFrame( this.loop )
      tickScroll = false
    }
  },
  mounted(){

    let scrollHandler = ()=>{
      if( ! tickScroll ){
        this.$store.commit('setScrollTop', this._getScrollTop())
        tickScroll = true 
      }
    }

    window.addEventListener('scroll', scrollHandler )
    window.addEventListener('touchmove', scrollHandler )
    window.addEventListener('resize', ()=>{
      this.$store.commit('resize')
    } )

    this.$store.commit('setScrollTop', this._getScrollTop())
    this.loop()

  }
};
</script>

<style lang="scss">
// @import './assets/scss/variables';
// @import './assets/scss/mixins';
// @import './assets/scss/default';
body{
  
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.8s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-leave-active {
  transition-duration: 1.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
